<template>
  <NuxtLink to="/" class="text-lg font-bold font-display tracking-tight flex items-center gap-2">
    <span>Local Authority</span>
    <UBadge color="primary" variant="subtle" class="font-sans">Alpha</UBadge>
  </NuxtLink>
</template>